import BaseEntityService from 'vue-core/services/BaseEntityService';
import env from 'environment';

class AnalysisService
    extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + '/analyses'
    });
  }
}

const service = new AnalysisService();

export default service;
